import { Diary } from "widgets/diary"

export const DiaryPage = () => {
  return <Diary />
}